export const ESignUpStatus = {
  CREATED: 'created',
  APPROVED: 'approved',
  REJECTED: 'rejected'
} as const;

export type ESignUpStatusValue = (typeof ESignUpStatus)[keyof typeof ESignUpStatus];
